class HttpErrorInterceptor {
    constructor($q, $rootScope, SERVICE_LOCATIONS, EVENTS, ErrorUtils) {
        return {
            responseError: (rejection) => {
                if (ErrorUtils.shouldNotify(rejection, SERVICE_LOCATIONS.CPM_API)) {
                    $rootScope.$emit(EVENTS.SHOW_NOTIFICATION, {
                        message: ErrorUtils.failureMessage(rejection, SERVICE_LOCATIONS.CPM_API),
                        errorMessage: rejection.data,
                        messageType: "error",
                        showDetailsOption: true
                    });
                }
                return $q.reject(rejection);
            }
        };
    }
}

angular.module('cpm')
    .factory('HttpErrorInterceptor', ['$q', '$rootScope', 'SERVICE_LOCATIONS', 'EVENTS', 'ErrorUtils',
        ($q, $rootScope, SERVICE_LOCATIONS, EVENTS, ErrorUtils) => new HttpErrorInterceptor($q, $rootScope, SERVICE_LOCATIONS, EVENTS, ErrorUtils)])
    .config(['$httpProvider', ($httpProvider) => {
        $httpProvider.interceptors.push('HttpErrorInterceptor');
    }]);
